/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="70.91"
        height="94.27"
        viewBox="0 0 70.91 94.27"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M35.35 74h5.3a1 1 0 0 0 1-1 .74.74 0 0 0 0-.21l-3-13.15v-.19a.94.94 0 0 1 .41-.76 6.65 6.65 0 1 0-7 0 .94.94 0 0 1 .4.76.6.6 0 0 1 0 .19l-3 13.11v.21a1 1 0 0 0 1 1Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M44.72 0a10.48 10.48 0 0 1 10.46 10.18v17.14a1.251 1.251 0 0 1-2.5.12v-17a8 8 0 0 0-7.72-8H26.19a8 8 0 0 0-8 7.72v5.13a1.24 1.24 0 0 1-1.18 1.31 1.27 1.27 0 0 1-1.25-1.13v-5A10.5 10.5 0 0 1 25.92 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M66.43 26.07H4.49A4.5 4.5 0 0 0 0 30.55v59.24a4.49 4.49 0 0 0 4.49 4.48h61.94a4.48 4.48 0 0 0 4.48-4.48V30.55a4.49 4.49 0 0 0-4.48-4.48Zm-61.94 2.5h61.94a2 2 0 0 1 2 2v59.24a2 2 0 0 1-2 2H4.49a2 2 0 0 1-2-2V30.55a2 2 0 0 1 2-1.98Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PadlockDisengagedIcon';

export default Icon;
